<template>
  <li>
    <a :href="link" class="dropdown-item" :target="target"> {{ title }}</a>
  </li>
</template>

<script>
export default {
  props: {
    title: String,
    link: String,
    target: String,
  },
};
</script>
<style lang="scss" scoped>
</style>